export default "__VITE_ASSET__DbHAioIl__"